import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AppComponent } from './app.component';
import { HeaderInterceptor } from './utils/http-interceptor';
import { AppRoutingModule } from './app-routing.module';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { SharedModule } from './utils/shared.module';
import { TranslatePipe } from './pipes/translate.pipe';
import { StoreModule } from '@ngrx/store';
import { reducers, metaReducers } from './store/reducers';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { environment } from './../environments/environment';
import { EffectsModule } from '@ngrx/effects';
import { StoreRouterConnectingModule, FullRouterStateSerializer } from '@ngrx/router-store';
import { WindowRef } from './services/window.service';
import { AnalyticsService } from './services/analytics/';
import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader, TRANSLATE_HTTP_LOADER_CONFIG } from '@ngx-translate/http-loader';
import { UpaService } from './services/upa/upa.service';
import { CookieService } from 'ngx-cookie-service';
import { TrackingService } from './services/tracking/tracking.service';

@NgModule({ declarations: [AppComponent, TranslatePipe],
    exports: [TranslateModule],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        SharedModule,
        StoreModule.forRoot(reducers, {
            metaReducers,
            runtimeChecks: {
                strictStateImmutability: false,
                strictActionImmutability: false
            }
        }),
        !environment.production ? StoreDevtoolsModule.instrument({ connectInZone: true }) : [],
        EffectsModule.forRoot([]),
        // Connects RouterModule with StoreModule
        StoreRouterConnectingModule.forRoot({ serializer: FullRouterStateSerializer }),
        CommonModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useClass: TranslateHttpLoader
            },
            isolate: false
        })], providers: [
        { provide: HTTP_INTERCEPTORS, useClass: HeaderInterceptor, multi: true },
        {
            provide: TRANSLATE_HTTP_LOADER_CONFIG,
            useValue: {
                prefix: `${globalThis.basePath}translations/`,
                suffix: ''
            }
        },
        WindowRef,
        CookieService,
        AnalyticsService,
        UpaService,
        TrackingService,
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule {}
